// @core/api/endpoints/team/create_team_banner.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTeamBannerRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Upload team banner
 * Uploads a new banner image for the team profile. Replaces any existing banner.
 */
export async function CreateTeamBanner(
  team_id: string,
  data: CreateTeamBannerRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/banner`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
